import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['results', 'quickResults', 'resultsList'];

  static values = { searchUrl: String, minChars: Number };

  initialize() {
    this.searchUrl = this.searchUrlValue || '/search/quick';
    this.minChars = this.minCharsValue || 2;
    this.searchTimeout = null;
  }

  focusInput() {
    // Focus the search input when the modal opens
    const input = this.element.querySelector('input[type="search"]');
    if (input) {
      setTimeout(() => {
        input.focus();
      }, 100); // slight delay to ensure modal is fully visible
    }
  }

  async search(event) {
    const query = event.target.value.trim();

    clearTimeout(this.searchTimeout);

    if (query.length < this.minChars) {
      this.quickResultsTarget.style.display = 'none';
      return;
    }

    // Debounce the search request
    this.searchTimeout = setTimeout(() => {
      this.performSearch(query);
    }, 300);
  }

  async performSearch(query) {
    try {
      const response = await fetch(`${this.searchUrl}?query=${encodeURIComponent(query)}`);

      if (!response.ok) {
        throw new Error('Search failed');
      }

      const data = await response.json();
      this.displayResults(data);
    } catch (error) {
      console.error('Quick search error:', error);
    }
  }

  displayResults(data) {
    const { results = [] } = data;

    if (results.length === 0) {
      this.quickResultsTarget.style.display = 'none';
      return;
    }

    // Clear previous results
    this.resultsListTarget.innerHTML = '';

    // Add new results
    results.forEach((result) => {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = result.url || '#';
      link.textContent = result.title || result.name;
      li.appendChild(link);
      this.resultsListTarget.appendChild(li);
    });

    this.quickResultsTarget.style.display = 'block';
  }
}
